import { render, staticRenderFns } from "./DGAnagrafiche.vue?vue&type=template&id=0f7257c7&scoped=true&"
import script from "./DGAnagrafiche.vue?vue&type=script&lang=js&"
export * from "./DGAnagrafiche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7257c7",
  null
  
)

export default component.exports